import React from "react";
import { Button, ButtonProps } from "antd";

type AppButtonVariant = "primary" | "secondary" | "subtle" | "text";
type AppButtonSize = ButtonProps["size"];

export type AppButtonProps = ButtonProps & {
  variant?: AppButtonVariant;
  size?: AppButtonSize;
};

const BASE_STYLE: React.CSSProperties = {
  borderRadius: 8,
  fontWeight: 500,
  minWidth: 80,
};

const SIZE_STYLES: Record<AppButtonSize, React.CSSProperties> = {
  small: {
    height: 28,
    fontSize: 12,
    paddingInline: 10,
  },
  middle: {
    height: 33,
    fontSize: 13,
    paddingInline: 12,
  },
  large: {
    height: 40,
    fontSize: 14,
    paddingInline: 16,
  },
};

const VARIANT_STYLES: Record<AppButtonVariant, React.CSSProperties> = {
  primary: {
    backgroundColor: "var(--blue-700)",
    border: "none",
    color: "white",
  },
  secondary: {
    backgroundColor: "var(--gray-300)",
    border: "none",
    color: "var(--gray-600)",
    boxShadow: "none",
    textShadow: "none",
  },
  subtle: {
    backgroundColor: "var(--gray-200)",
    border: "none",
    color: "var(--blue-700)",
    boxShadow: "none",
    textShadow: "none",
  },
  text: {
    backgroundColor: "transparent",
    border: "none",
    color: "var(--blue-700)",
    boxShadow: "none",
    textShadow: "none",
    // minWidth: "auto",
    // height: "auto",
    // paddingInline: 8,
    // paddingBlock: 0,
  },
};

export const AppButton: React.FC<AppButtonProps> = (props) => {
  const { variant = "primary", size = "middle", style, children, ...rest } = props;

  return (
    <Button
      {...rest}
      style={{
        ...BASE_STYLE,
        ...SIZE_STYLES[size],
        ...VARIANT_STYLES[variant],
        ...style,
      }}
    >
      {children}
    </Button>
  );
};
